<template>
  <div
    class="team-banner"
    @click="()=>{goToPlace(site)}"
    v-bind:style="{ backgroundImage: 'url(' + photo + ')' }"
  >
  </div>
</template>

<script>
import mixin from '../mixin';

export default {
  mixins: [mixin]
}
</script>

<style scoped lang="scss">
  .team-banner {
    width: 100%;
    padding-bottom: 28%;
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 1rem auto 0 auto;
    cursor: pointer;
  }
</style>
